import t from"react";import{StyledTypography as e}from"./styles.js";const o=({testId:o,color:r,...a})=>t.createElement(e,{...a,ownerState:{color:r},"data-testid":o});export{o as default};
//# sourceMappingURL=Typography.js.map
